/* eslint-disable import/prefer-default-export */
import React from 'react';
import { oneOfType, PropTypes } from 'prop-types';
import get from 'lodash/get';
import Skeleton from 'Common/Components/Skeleton';
import { Wrapper, Link } from './styled';

const getCweList = (vuln) => {
  const cwe = get(vuln, 'cwe', []);
  if (Array.isArray(cwe)) return cwe.filter(Boolean);
  return cwe ? [cwe] : [];
};

export const CWE = ({ vuln, showSkeleton }) => {
  const cwes = getCweList(vuln);

  if (showSkeleton) return <Skeleton />;
  if (cwes.length === 0) return null;

  return (
    <Wrapper>
      {cwes.map((cwe, index) => (
        <Link
          target="_blank"
          rel="noopener noreferrer"
          href={ `https://cwe.mitre.org/data/definitions/${cwe.replace(/^CWE-/i, '')}.html` }
          key={ `${cwe}-${index}` }
        >
          {cwe}
        </Link>
      ))}
    </Wrapper>
  );
};

CWE.propTypes = {
  vuln: oneOfType([PropTypes.object, PropTypes.number]).isRequired,
  showSkeleton: PropTypes.bool.isRequired
};
